import { Device } from "enums/device";
import md5 from "md5";
import { ApiPayload } from "types/api";

export const payloadHelper = (
  methodName: string,
  typeName: string | number | null,
  data: any,
  device?: number
) => {
  const agentId = process.env.REACT_APP_AGENT_ID as string;
  const secretKey = process.env.REACT_APP_SECRET_KEY as string;
  const signature = typeName
    ? md5(agentId + typeName + secretKey)
    : md5(agentId + secretKey);

  const payload: ApiPayload<any> = {
    agentId,
    signature,
    data,
    method: methodName,
    syslang: 1,
    device: device || Device.WEB,
  };
  if (!data) {
    delete payload["data"];
  }

  return payload;
};
